import React from 'react';

const Quote = () => (
  <section id="quote-id">
    <p>
      &quot;Mathematics is not about numbers, equations, computations, or algorithms:
      it is about understanding&quot; - William Paul Thurston
    </p>
  </section>
);
export default Quote;
